import React, {useCallback, useContext, useMemo, useState} from "react";
import {Snack, SnackbarContext} from "@/context/SnackbarContext";
import {DataGrid, GridColDef} from "@mui/x-data-grid";
import {Admin} from "@models/admin";
import {Box, Button, IconButton,} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {useQuery} from "react-query";
import {QUERY_KEY} from "@/data/query-key";
import {PageSizeOptions} from "@/data/options";
import {getCourses} from "@/api/course";
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import dayjs from "dayjs";

export default function CourseList() {

    const {snack, setSnack} = useContext(SnackbarContext);

    const columns: GridColDef[] = [
        {
            field: '_id',
            headerName: '課程ID',
            sortable: false,
            flex: 1,
            minWidth: 200
        },
        {
            field: 'title',
            headerName: '標題',
            sortable: false,
            flex: 1,
            minWidth: 200,
            renderCell: ({ row }) => {
                return (
                    <Box>
                        { row.title.zh }
                    </Box>
                )
            }
        },
        {
            field: 'createdAt',
            headerName: '創建日期',
            sortable: false,
            flex: 1,
            minWidth: 120,
            renderCell: ({ row }) => {
                return (
                    <Box>
                        { dayjs(row.createdAt).format('DD/MM/YYYY') }
                    </Box>
                )
            }
        },
        {
            field: 'action',
            headerName: '行動',
            sortable: false,
            minWidth: 120,
            renderCell: ({ row }) => {
                return (
                    <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
                        <IconButton
                            color='primary'
                            size='small'
                            sx={{ ml: 0.5 }}
                            component={RouterLink}
                            to={`/courses/edit/${row._id}`}
                        >
                            <EditIcon></EditIcon>
                        </IconButton>
                    </Box>
                )
            }
        }
    ]

    const [paginationModel, setPaginationModel] = useState<{page: number, pageSize: number}>({
        page: 0,
        pageSize: 50
    })
    const [keyword, setKeyword] = useState<string | null>(null)

    const query = {
        count: String(paginationModel.pageSize),
        page: String(paginationModel.page + 1),
        keyword,
        // type: ,
        // level: ,
    }

    const { data, refetch, isLoading } = useQuery(
        [QUERY_KEY.COURSE_LIST, query],
        async () => {
            return (await getCourses({
                skip: paginationModel.pageSize * paginationModel.page,
                limit: paginationModel.pageSize,
                count: true,
                ...(!!keyword && {keyword}),
                // ...(!!type && {type}),
                // ...(!!level && {level})
            })).data
        }
    )

    const courseList = useMemo(() => {
        if (!data)
            return []
        return data.courses.map(u => ({
            id: u._id, // Add id for MUI
            ...u
        }))
    }, [data])

    /***
     * Row actions
     */

    return (
        <>
            <Button variant="contained" component={RouterLink} to="/courses/add">
                新增
            </Button>

            <DataGrid
                sx={{
                    mt: 2,
                    backgroundColor: 'white'
                }}
                loading={isLoading}
                rows={courseList}
                columns={columns}

                pagination
                paginationMode='server'
                paginationModel={paginationModel}
                rowCount={data?.count || 0}
                pageSizeOptions={PageSizeOptions}
                onPaginationModelChange={setPaginationModel}

                disableColumnFilter
                disableColumnMenu
                disableColumnSelector
                disableRowSelectionOnClick
            />
        </>
    )



}